import { render, staticRenderFns } from "./UserRevocations.vue?vue&type=template&id=6c976bde&scoped=true"
import script from "./UserRevocations.vue?vue&type=script&lang=js"
export * from "./UserRevocations.vue?vue&type=script&lang=js"
import style0 from "./UserRevocations.vue?vue&type=style&index=0&id=6c976bde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c976bde",
  null
  
)

export default component.exports